import { gql } from '@apollo/client';

export const SSO_CALLBACK = gql`
  mutation SSOCallback($code: String!, $codeVerifier: String!, $redirectUri: String) {
    ssoCallback(code: $code, codeVerifier: $codeVerifier, redirectUri: $redirectUri) {
      success
      user {
        id
        email
        given_name
        family_name
      }
      error
      idToken
      accessToken
      refreshToken
    }
  }
`;
